import { render } from "./ImmigrationServices.vue?vue&type=template&id=46847eaa&scoped=true"
import script from "./ImmigrationServices.vue?vue&type=script&lang=js"
export * from "./ImmigrationServices.vue?vue&type=script&lang=js"

import "./ImmigrationServices.vue?vue&type=style&index=0&id=46847eaa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46847eaa"]])

export default __exports__